import React from 'react';
import * as PropTypes from 'prop-types';
import classNames from 'classnames';
import CustomMenuItems from './CustomMenuItems';
import { safeHTML } from '../../../../utils/safeHTML';
import CustomMenuButton from './CustomMenuButton';
import Icon from '../icon/Icon';
import { startContent, copyrightParams } from '../../../../constants/copyright';
import Volume from '../volume/Volume';
import { useUser } from '../../../../redux/reducer/user';
import { useTranslation, defaultStore, stores } from '../../../../translations';
import { useAppState } from '../../../../redux/reducer/content';
import SelectLangButton from '../../../features/selectLangButton/SelectLangButton';
import SelectCountryButton from '../../../features/selectCountryButton/SelectCountryButton';
import { useRequests } from '../../../../redux/reducer/requests';
import { START } from '../../../../constants/shared/states/names';
import { useFeatureToggle } from '../../../../hooks/useFeatureToggle';

export default function CustomMenu({ customMenuItems, title, buttons, copyright, wrapperLogo }) {
  const { profile: { username } = {} } = useUser();
  const { t } = useTranslation();
  const {
    appInfoData,
    authData: { isWeb },
  } = useRequests();
  const { state: appState } = useAppState();
  const isStartScreen = appState === START;

  const gameTamagotchiEnableCountrySelect = useFeatureToggle('gameTamagotchiEnableCountrySelect');
  const shouldShowCountrySelect = gameTamagotchiEnableCountrySelect && buttons?.some((item) => item.isCountry);

  return (
    <nav className={classNames('custom-menu', { 'custom-menu_app': !isWeb })}>
      <label htmlFor={'menu-burger'} className={'custom-menu__close'}>
        <Icon name={'back_customization'} />
      </label>
      <strong className='custom-menu__title'>{safeHTML(t(title))}</strong>
      <ul className={'custom-menu__list'}>
        <CustomMenuItems items={customMenuItems} />
      </ul>
      <div className='custom-menu__section'>
        <Volume {...startContent.button} className={'custom-menu__mute'} />
        {/* <div className={classNames("custom-menu__id", {
          "custom-menu__id_big": username.length > 20
        })}>{username}</div> */}
        {defaultStore !== stores.ru && <SelectLangButton isIcon className={'custom-menu__select-lang'} />}
        {shouldShowCountrySelect && <SelectCountryButton isIcon className={'custom-menu__country'} />}
      </div>
      <div className='custom-menu__buttons'>
        {buttons?.map((item, index) => {
          if (appInfoData?.isWeb === false && item.isMobileApp) {
            return null;
          }
          if (item.isVolume) return <Volume key={`btn-${index}`} {...item} />;
          if (item.isLang && defaultStore !== stores.ru)
            return <SelectLangButton isIcon key={`btn-${index}`} {...item} />;
          if (item.isCountry) {
            if (isStartScreen && gameTamagotchiEnableCountrySelect) {
              return <SelectCountryButton isIcon key={`btn-${index}`} {...item} />;
            }
            return null;
          }

          return <CustomMenuButton {...item} key={`btn-${index}`} />;
        })}
      </div>
      <span className='custom-menu__copyright'>{safeHTML(t(copyright, copyrightParams))}</span>
      {wrapperLogo && wrapperLogo}
    </nav>
  );
}

CustomMenu.propTypes = {
  customMenuItems: PropTypes.array,
};
